export default __webpack_public_path__ + "static/fonts/Source_Han_Sans_CN_Normal.aac26a3.otf";